import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import About from './pages/About';
import Services from './pages/Services';
import HowItWorks from './pages/HowItWorks';
import WhyChoose from './pages/WhyChoose';
import Products from './pages/Products';
import ClientRequest from './pages/ClientRequest';
import Contact from './pages/Contact';
import ScrollToTop from './ScrollToTop';
import TapDebugger from './components/TapDebugger'; // still here for testing

function App() {
  return (
    <Router>
      <ScrollToTop />
      <TapDebugger /> {/* Only activates with ?tapdebug=1 */}
      <div className="App">
        <Helmet>
          <title>Pure Drop Technicals - Water Shop Installations & Purification Systems</title>
          <meta
            name="description"
            content="Professional water shop installations, commercial water purification plants, and alkaline water systems in South Africa. Start your water business with Pure Drop."
          />
          <meta
            name="keywords"
            content="water shop installation South Africa, water purification plant SA, alkaline water filter system, start a water business"
          />
          <meta property="og:title" content="Pure Drop Technicals - Water Solutions" />
          <meta
            property="og:description"
            content="Professional water shop installations and commercial purification plants in South Africa"
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.watershopinstallations.co.za" />
        </Helmet>

        <Header />

        <main>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/why-choose" element={<WhyChoose />} />
            <Route path="/products" element={<Products />} />
            <Route path="/request" element={<ClientRequest />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;